import { useEffect, useState } from "react";

import { getApi } from "../../../../apis/api";
import { GET_EXCEPTION_GROUP } from "../../../../apis/end-points";

export interface ExceptionGroup {
  id: string;
  name: string;
}

/**
 * Whether the Exception group exists (KAN-1347): the Communications menu shows Exceptions only while it does,
 * so deleting the group takes the entry away. Asked again on each move within Communications.
 */
const useExceptionGroup = (enabled: boolean, pathname: string) => {
  const [group, setGroup] = useState<ExceptionGroup | null>(null);
  const inCommunications = pathname.startsWith("/communications");

  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    getApi<ExceptionGroup | null>(GET_EXCEPTION_GROUP)
      .then((response) => {
        if (active && response.success) setGroup(response.data ?? null);
      })
      .catch(() => undefined); // The menu just keeps what it last knew
    return () => {
      active = false;
    };
    // `inCommunications ? pathname : ""`: refreshed while moving within Communications, not on every page
  }, [enabled, inCommunications ? pathname : ""]); // eslint-disable-line react-hooks/exhaustive-deps

  return group;
};

export default useExceptionGroup;
